import React, {useState} from "react";
import {connect} from "react-redux";
import {Layout, Menu} from "antd";
import {MenuFoldOutlined, MenuUnfoldOutlined} from '@ant-design/icons';
import Logo from './Logo';
import NavProfile from './NavProfile';
import NavSearch from './NavSearch';
import {onMobileNavToggle, toggleCollapsedNav} from 'redux/actions/Theme';
import {NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH} from 'constants/ThemeConstant';
import utils from 'utils'
import NavNotification from "./NavNotification";
import NotificationIngredientStock from "./NotificationIngredientStock";
import NotificationPackagingStock from "./NotificationPackagingStock";
import {APP_NAME} from "../../configs/AppConfig";
import NotificationOverheads from "./NotificationOverheads";
import DebtorsNotification from "./DebtorsNotification";

const {Header} = Layout;

export const HeaderNav = props => {
    const {navCollapsed, mobileNav, navType, headerNavColor, toggleCollapsedNav, onMobileNavToggle, isMobile} = props;
    const [searchActive, setSearchActive] = useState(false)

    const onSearchClose = () => {
        setSearchActive(false)
    }

    const onToggle = () => {
        if (!isMobile) {
            toggleCollapsedNav(!navCollapsed)
        } else {
            onMobileNavToggle(!mobileNav)
        }
    }

    const isNavTop = navType === NAV_TYPE_TOP ? true : false
    const mode = utils.getColorContrast(headerNavColor)
    const getNavWidth = () => {
        if (isNavTop || isMobile) {
            return '0px'
        }
        if (navCollapsed) {
            return `${SIDE_NAV_COLLAPSED_WIDTH}px`
        } else {
            return `${SIDE_NAV_WIDTH}px`
        }
    }
    return (
        <Header className={`app-header ${mode}`} style={{backgroundColor: headerNavColor}}>
            <div className={`app-header-wrapper ${isNavTop ? 'layout-top-nav' : ''}`}>
                <Logo logoType={mode}/>
                <div className="nav" style={{width: `calc(100% - ${getNavWidth()})`}}>
                    <div className="nav-left">
                        <Menu mode="horizontal">
                            {
                                isNavTop && !isMobile ?
                                    null
                                    :
                                    <Menu.Item key="0" onClick={() => {
                                        onToggle()
                                    }}>
                                        {navCollapsed || isMobile ? <MenuUnfoldOutlined className="nav-icon"/> :
                                            <MenuFoldOutlined className="nav-icon"/>}
                                    </Menu.Item>
                            }
                        </Menu>
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                        <img style={{transform: 'rotate(-0.5deg)'}} width={150} height={80}
                             src='/img/logo_letras_blanco_2.png' alt={`${APP_NAME} logo`}/>
                    </div>
                    <div className="nav-right ml-0 d-flex align-items-center">
                        <DebtorsNotification/>
                        <NotificationOverheads/>
                        <NotificationPackagingStock/>
                        <NotificationIngredientStock/>
                        <NavNotification/>
                        <NavProfile/>
                    </div>
                    <NavSearch active={searchActive} close={onSearchClose}/>
                </div>
            </div>
        </Header>
    )
}

const mapStateToProps = ({theme}) => {
    const {navCollapsed, navType, headerNavColor, mobileNav} = theme;
    return {navCollapsed, navType, headerNavColor, mobileNav}
};

export default connect(mapStateToProps, {toggleCollapsedNav, onMobileNavToggle})(HeaderNav);
